import { useState } from "react";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import { upgradeFirmware } from "../../../containers/Validation/cloudTool";

export default function FirmwareUpgrade(props) {
  const { key, isLoading = false, handleSubmitModalCommand = () => { }, commandDetails = {}, } = props?.globalModal.data || {};

  const [details, setDetails] = useState({});
  const [errors, setErros] = useState({})

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const request = { ...commandDetails };
    request.packet[1] = details;

    const { isValid, errors } = upgradeFirmware(request?.packet?.[1]);
    if (!isValid) {
      setErros(errors);
      return;
    } else {
      setErros({});
    }
    handleSubmitModalCommand(key, request);
    props.closeModal();
  };

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex">
          <h6>Firmware Upgrade</h6>
        </Grid>
      </DialogTitle>

      <DialogContent dividers className="heat_pump_dialog_content heat-modal-content">
        <FormControl variant="outlined" fullWidth>
          <FormLabel>OTA URL</FormLabel>
          <TextField
            type="text"
            variant="outlined"
            placeholder="Enter OTA URL"
            name="url"
            value={details?.url || ""}
            onChange={handleChange}
          />
          {errors?.url && (
            <FormHelperText style={{ color: "red", textAlign: "left", padding: "0px", margin: "0px" }}>
              {errors?.url}
            </FormHelperText>
          )}
        </FormControl>
        <FormControl variant="outlined" fullWidth>
          <FormLabel>Md5</FormLabel>
          <TextField
            type="text"
            variant="outlined"
            placeholder="Enter md5 value"
            name="md5"
            value={details?.md5 || ""}
            onChange={handleChange}
          />
          {details?.md5 ? (
            <FormHelperText style={{ color: "red", textAlign: "left", padding: "0px", margin: "0px", }}>
              {errors.md5}
            </FormHelperText>
          ) : null}
        </FormControl>
      </DialogContent>
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${isLoading[key] || !details.url ? "disabled" : ""}`}
            onClick={isLoading[key] || !details.url ? null : handleSubmit}
          >
            {isLoading[key] ? <CircularProgress size={18} color="white" /> : "Submit"}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
